import { LateralMenu } from 'components/Layout/LateralMenu/LateralMenu';
import { SidePanel } from 'components/SidePanel/SidePanel';
import { type JSX, useEffect, useState } from 'react';

import { hamburgerDrawerPaperSx } from './HamBurgerSlidePanel.style';

type Props = {
  isOpen: boolean;
  onAbort: () => void;
};

export const HumBurgerSidePanel = ({ isOpen, onAbort }: Props): JSX.Element => {
  const [drawerOpen, setDrawerOpen] = useState(isOpen);
  useEffect(() => {
    setDrawerOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      <SidePanel
        title={''}
        isOpen={drawerOpen}
        onClose={onAbort}
        widthInPercent={20}
        anchor="left"
        isMobile={true}
        paperSx={hamburgerDrawerPaperSx}
        isHamburgerPanel={true}
      >
        <LateralMenu closeMenu={onAbort} />
      </SidePanel>
    </>
  );
};
